import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ endTime, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = Date.now();
      const difference = endTime - now;
      return Math.max(0, difference);
    };

    setTimeLeft(calculateTimeLeft());

    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (newTimeLeft <= 0 && onComplete) {
        onComplete();
        clearInterval(interval);
      }
    }, 100); // Обновляем каждые 100мс для плавности

    return () => clearInterval(interval);
  }, [endTime, onComplete]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.ceil(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return {
      minutes,
      seconds,
      totalSeconds
    };
  };

  const { minutes, seconds, totalSeconds } = formatTime(timeLeft);
  const totalDuration = 3 * 60; // 3 минуты в секундах
  const progress = ((totalDuration - totalSeconds) / totalDuration) * 100;

  if (timeLeft <= 0) {
    return (
      <div className="flex items-center justify-center p-4 bg-green-50 border border-green-200 rounded-lg">
        <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span className="text-green-800 font-medium">Форма разблокирована!</span>
      </div>
    );
  }

  return (
    <div className="p-4 bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 rounded-lg">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          <svg className="w-5 h-5 text-orange-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm font-medium text-orange-900">Форма заблокирована</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="text-right">
            <div className="text-2xl font-bold text-orange-600 tabular-nums">
              {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
            </div>
          </div>
        </div>
      </div>

      {/* Progress bar */}
      <div className="relative h-2 bg-orange-200 rounded-full overflow-hidden">
        <div 
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-orange-500 to-red-500 transition-all duration-100 ease-linear"
          style={{ width: `${progress}%` }}
        />
      </div>

      <p className="text-xs text-orange-700 mt-2">
        Для защиты системы действует временная блокировка на 3 минуты после использования.
      </p>
    </div>
  );
};

export default CountdownTimer;











